import type { GateResult } from "@exploitlens/ui-contracts";

import { GateBadge } from "./GateBadge";

/** The four gates, in the fixed order the receipt always carries them in. */
export function GateStrip({ gates }: { gates: GateResult[] }) {
  return (
    <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {gates.map((gate) => (
        <li key={gate.gate}>
          <GateBadge gate={gate} />
        </li>
      ))}
    </ul>
  );
}
